import _ from 'lodash';
import { stringToKey } from 'src/app/shared/string-to-key';
import { arrangerRestrictedProductType } from '../../form-enum';

/**
 * Which of `disabledCategories` a product (or its category) falls under, or null when none (#167). Pure; tested in
 * disabled-products.spec.ts.
 *
 * Match on category keys, not on display text: a key is stringToKey(name), and its hyphen parts cover names like
 * 'Celebrant Services' or 'Funeral Conductor - Weekend'.
 */
export function disabledProductCategory(
  disabledCategories: string[] | null | undefined,
  ...values: (string | null | undefined)[]
): string | null {
  if (!disabledCategories?.length) {
    return null;
  }

  const keys = _.flatMap(values, (value) => {
    const key = stringToKey(value ?? '');

    return key ? [key, ...key.split('-')] : [];
  });

  return disabledCategories.find((term) => keys.includes(stringToKey(term))) ?? null;
}

/**
 * What the arranger's own line items disable on the Book Arrangement Meeting page (#167, as settled by Ivan on
 * 2026-10-29): the arranger can't be the conductor. That's all; Celebrant and everything else stay open.
 */
export const ARRANGER_DISABLED_PRODUCTS: Readonly<Record<string, string>> = {
  [arrangerRestrictedProductType.Conductor]: "Not available — arrangers can't be conductors on the day.",
};
